import { ArrowRight } from 'lucide-react';

const REGISTER_URL = 'https://app.theonestack.com/research';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden bg-ink-900 py-24">
      <div className="absolute inset-0 -z-10 glow-pink opacity-60" />
      <div className="mx-auto max-w-4xl px-6 text-center">
        <h2 className="mb-6 text-4xl font-black leading-tight tracking-tight text-white sm:text-5xl md:text-6xl">
          Stop researching.{' '}
          <span className="bg-gradient-to-r from-rose-400 to-violet-500 bg-clip-text text-transparent">
            Start finding.
          </span>
        </h2>
        <p className="mx-auto mb-10 max-w-2xl text-lg text-slate-400">
          Free to sign up with $5 in research credit. No card. Bring your first
          research goal and we'll show you the answer in minutes.
        </p>
        <a
          href={REGISTER_URL}
          className="group inline-flex items-center gap-2 rounded-xl bg-rose-500 px-10 py-5 text-lg font-semibold text-white transition-all hover:bg-rose-400 hover:shadow-2xl hover:shadow-rose-500/40"
        >
          Start free with $5 credit
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" />
        </a>
        <p className="mt-6 text-sm text-slate-500">
          Already a Mission, Build, or Voice customer? It's already in your product launcher.
        </p>
      </div>
    </section>
  );
}
